module.exports = __webpack_public_path__ + "static/img/viral_23.8534fbb3.jpg";